module.exports = __webpack_public_path__ + "img/isdin.34ad46a6.jpeg";